import { cookie } from '@ifeng-fe/ui_base';

export const createUid = () => {
    if (cookie.get('userid') !== '') return cookie.get('userid');
    const key = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';
    let ramStr = parseInt(Math.random() * 268435455).toString(2);
    let mtimeStr = new Date().getTime();

    mtimeStr = mtimeStr.toString(2);
    while (ramStr.length < 28) ramStr = `0${ramStr}`;
    while (mtimeStr.length < 44) mtimeStr = `0${mtimeStr}`;

    const binaryStr = ramStr + mtimeStr;
    let outStr = '';

    for (let i = 0; i < 12; i++) outStr += key.charAt(parseInt(binaryStr.substr(i * 6, 6), 2));

    return outStr;
};

export const getQuery = (url, key) => {
    let value = '';

    try {
        const urlObj = new URL(url);
        const { searchParams } = urlObj;

        if (searchParams.has(key)) {
            value = searchParams.get(key);
        }
    } catch (e) {
        console.error(e);
    }

    return value;
};

// 根据时间戳分别获取年月日 格式为：2020-01-11
export const getDate = (timestamp) => {
    timestamp = timestamp ? timestamp : Date.parse(new Date());
    const date = new Date(timestamp * 1000);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const week = date.getDay();
    const weekZh = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

    // 分别返回年月日 不满10的前面补0
    return {
        year,
        month: month < 10 ? `0${month}` : month,
        day: day < 10 ? `0${day}` : day,
        week: weekZh[week],
    };
};

// // 等待所有图片加载完成后滚动到底部
export const getImgLoadEd = (dom, callback) => {
    // 查询容器下所有图片
    const images = dom.querySelectorAll('img');

    if (images.length > 0) {
        // Array.prototype.slice.call将images类数组转换成合法数组
        const promises = Array.prototype.slice.call(images).map((node) => {
            return new Promise((resolve, reject) => {
                const loadImg = new Image();

                loadImg.src = node.src;
                loadImg.onload = () => {
                    resolve(node);
                };
            });
        });

        // 利用Promise.all监听所有图片加载完成
        Promise.all(promises)
            .then((results) => {
                callback();
            })
            .catch((e) => {
                callback();
                console.error('网络异常或其他程序异常', e);
            });
    } else {
        callback();
    }
};
